// src/components/common/LanguageSwitcher.jsx
import React from 'react';
import { Dropdown } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTheme } from '../../context/ThemeContext';
import { LANGUAGES } from '../../lib/i18n';

export default function LanguageSwitcher() {
    const { locale, setLocale } = useTheme();
    const current = LANGUAGES.find((l) => l.code === locale) || LANGUAGES[0];

    const menu = {
        items: LANGUAGES.map((l) => ({
            key: l.code,
            label: (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, minWidth: 120 }}>
                    <span style={{ fontWeight: locale === l.code ? 700 : 500 }}>{l.nativeLabel}</span>
                    <span style={{ color: 'var(--home-fg-muted)', fontSize: 12 }}>{l.label}</span>
                    {locale === l.code && (
                        <span style={{ marginInlineStart: 'auto', color: 'var(--home-accent)' }}>✓</span>
                    )}
                </span>
            ),
            onClick: () => setLocale(l.code),
        })),
    };

    return (
        <Dropdown menu={menu} trigger={['click']} placement="bottomRight">
            <button type="button" className="nav__lang" aria-label="Change language">
                <GlobalOutlined />
                <span>{current.code.toUpperCase()}</span>
            </button>
        </Dropdown>
    );
}